import React, { useState } from 'react';
import Popup from '../Popup/Popup';
import './StoreAddress.scss';

function openMaps(event, props, googleUrl, lat, lng, setShowMap) {
  const { triggerDtmOnClick, desktopFlow, pfuStoreAddress, ispfuStoreAddress } = props;
  if (triggerDtmOnClick && typeof triggerDtmOnClick === 'function') {
    triggerDtmOnClick('store directions');
  }
  if (googleUrl) {
    if (desktopFlow) {
      window.open(googleUrl, '_blank').focus();
    } else if (pfuStoreAddress || ispfuStoreAddress) {
      setShowMap(true);
    } else {
      window.location.href = googleUrl;
    }
  } else if (lat && lng) {
    if (desktopFlow) {
      window.open(`https://maps.google.com/?q=${lat},${lng}`, '_blank').focus();
    } else if (pfuStoreAddress || ispfuStoreAddress) {
      setShowMap(true);
    } else {
      window.location.href = `https://maps.google.com/?q=${lat},${lng}`;
    }
  }
  event.preventDefault();
}

function getTime(time) {
  if (!time) return '';
  const a = time.split(':');
  return `${a[0]}:${a[1]}`;
}

function StoreAddress(props) {
  const {
    callStore,
    headerLabel,
    fadeLabel,
    storeDetails,
    visiAppointement,
    changeStoreAddress,
    lat,
    lng,
    triggerDtmOnClick,
    dataLocale,
    desktopFlow,
    desktopFlowSuccess,
  } = props; // pass CallStore in case of CallStore shown, headerLabel in case of showing heading
  const {
    name,
    address,
    city,
    distance,
    pincode,
    googleUrl,
    openingTime,
    closingTime,
    phoneCode,
    telephone,
  } = storeDetails;
  const [showMapModal, setShowMap] = useState(false);
  const {
    CHANGE,
    TIMINGS,
    OPEN_BRACKET,
    CLOSE_BRACKET,
    PM,
    AM,
    ALL_DAYS,
    SYMBOL_COLON,
    HYPHEN,
    DIRECTIONS,
    CALL_STORE,
    NOT_ABLE_TO_SHOW_MAP,
  } = dataLocale;
  const showMapBottomSheet = () => {
    let mapUrl;
    const embed = '&output=embed';
    if (googleUrl) mapUrl = googleUrl;
    else if (lat && lng) mapUrl = `https://maps.google.com/?q=${lat},${lng}`;
    return mapUrl.includes('https://maps.google.com') ? (
      <Popup backdrop expanded storeAddressPfu onClickBackdrop={() => setShowMap(false)}>
        <div className="mr-r10 fsp18" style={{ float: 'right' }} onClick={() => setShowMap(false)}>
          x
        </div>
        <div
          className="mr-t5 pd-4 bg-pale_grey"
          style={{
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            paddingTop: '56.25%',
            height: '600px',
          }}
        >
          <iframe
            allowFullScreen=""
            aria-hidden="false"
            frameBorder="0"
            height="600"
            loading="lazy"
            scrolling="no"
            src={mapUrl + embed}
            style={{ border: 0, position: 'absolute', top: '0', width: '100%' }}
            title={lat}
          />
        </div>
      </Popup>
    ) : (
      <div className="mr-t5 text-color_brick_red">{NOT_ABLE_TO_SHOW_MAP}</div>
    );
  };
  let storeAddress = '';
  if (address) storeAddress = address;
  if (city) storeAddress += `${storeAddress ? ', ' : ''}${city}`;
  storeAddress += `${storeAddress ? ' - ' : ''}${pincode}`;
  return (
    <div>
      {headerLabel && (
        <div className="display-flex justify-space-between roboto lh-16 pd-l0 pd-r0 pd-b10">
          <div
            className={`${
              fadeLabel ? 'fsp12 text-color_pale_black' : 'fsp14 fw500 text-color_grey_black'
            } ${
              desktopFlowSuccess || desktopFlow ? 'text-uppercase text-color-grey margin-b8' : ''
            }`}
          >
            {headerLabel}
          </div>
          {changeStoreAddress && !visiAppointement && (
            <div className="text-topaz fsp12 fw500" onClick={changeStoreAddress}>
              {CHANGE}
            </div>
          )}
        </div>
      )}
      <div
        className={`pd-r0 display-flex ${
          desktopFlow || desktopFlowSuccess
            ? 'justify-content-between'
            : 'text-color_dark_grey align-items-center'
        }`}
      >
        <div
          className={`address ${desktopFlow ? 'width-vw' : ''} ${
            desktopFlowSuccess ? 'margin-t10' : ''
          }`}
        >
          <div
            className={`fsp14 lh-16 ${desktopFlow || desktopFlowSuccess ? 'fs14 fw600' : 'fw500'}`}
          >
            {name}
          </div>
          <div
            className={`mr-t4  ${
              desktopFlow || desktopFlowSuccess
                ? 'fs14 text-color-grey fw500'
                : 'text-color_dull_black'
            }`}
          >
            {storeAddress}
          </div>
          {!desktopFlowSuccess && (
            <div className={`mr-t10 ${desktopFlow ? 'margin-t8 fw500 fs15' : ''}`}>
              {!desktopFlow && (
                <strong>
                  {TIMINGS}
                  {SYMBOL_COLON}
                </strong>
              )}
              {desktopFlow && (
                <span>
                  {TIMINGS}
                  {SYMBOL_COLON}{' '}
                </span>
              )}
              <span className={`${desktopFlow ? 'fs13 text-color-grey' : ''}`}>
                {getTime(openingTime)} {AM} {HYPHEN} {getTime(closingTime)} {PM} {OPEN_BRACKET}
                {ALL_DAYS}
                {CLOSE_BRACKET}
              </span>
            </div>
          )}
        </div>
        <div
          className={`flex-direction-column align-items-center mr-l15 ${
            desktopFlow || desktopFlowSuccess
              ? 'margin-r30 margin-l30 text-center fw500 '
              : 'display-flex'
          }`}
        >
          <div
            className="text-center"
            onClick={ev => {
              openMaps(ev, props, googleUrl, lat, lng, setShowMap);
            }}
          >
            <img
              alt={DIRECTIONS}
              aria-label="Click Here For Directions"
              className="sa-img cursor-pointer"
              src="https://static.lenskart.com/media/mobile/universal/images/returnExchange/Directions.svg"
            />
          </div>
          <div
            className={`fw700 mr-t5 ${desktopFlow ? 'text-uppercase text-topaz padding-t9' : ''}`}
          >
            {DIRECTIONS}
          </div>
          {!fadeLabel && distance && distance.humanReadable && (
            <span className={`mr-l5 ${desktopFlow ? 'text-color-grey' : ''}`}>
              {distance.humanReadable}
            </span>
          )}
        </div>
        {callStore && (
          <div className={`mr-l15 ${desktopFlow ? 'text-center' : ''}`}>
            <a
              aria-label={`Call Store At ${phoneCode}${telephone}`}
              className="text-center block"
              href={`tel:${phoneCode}-${telephone}`}
              onClick={() => triggerDtmOnClick('call store')}
            >
              <img
                alt={CALL_STORE}
                className="sa-img"
                src="https://static.lenskart.com/media/mobile/universal/images/returnExchange/CallStore.svg"
              />
            </a>
            <div
              className={`mr-t5 text-center nowrap ${
                desktopFlow ? 'text-color-grey text-uppercase padding-t9 fw500' : 'fw700'
              }`}
            >
              {CALL_STORE}
            </div>
            {desktopFlow && telephone && (
              <div
                className={`mr-t5 text-center nowrap ${
                  desktopFlow ? 'text-color-grey margin-t1 fw500' : 'fw700'
                }`}
              >
                {telephone}
              </div>
            )}
          </div>
        )}
      </div>
      {showMapModal && showMapBottomSheet()}
    </div>
  );
}

export default StoreAddress;
